import React, { useRef, useEffect, useState } from "react";
import styling from "./AddChannels.module.css";
import { MdClose } from "react-icons/md";
import { RiFacebookFill, RiAmazonFill } from "react-icons/ri";
import { FiInstagram } from "react-icons/fi";
import { AiOutlineYoutube } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { salesChannelAction } from "../../../redux/actions/actions";
import firebase from "../../../firebase/firebase";
import { notify, ToastContainer } from "../../Notify/Notify";

function AddChannels({ toggleChannel, guestUser }) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const salesChannel = useSelector((state) => state.salesChannel);

  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [amazon, setAmazon] = useState("");
  const [updateChannel, setUpdateChannel] = useState(false);

  useEffect(() => {
    if (salesChannel.facebook) {
      setFacebook(salesChannel.facebook || "");
      setInstagram(salesChannel.instagram || "");
      setYoutube(salesChannel.youtube || "");
      setAmazon(salesChannel.amazon || "");
      setUpdateChannel(true);
    }
  }, [salesChannel]);

  const handleSave = (mode) => {
    if (
      facebook.length > 6 ||
      instagram.length > 6 ||
      youtube.length > 6 ||
      amazon.length > 6
    ) {
      const userSalesChannels = {
        facebook,
        instagram,
        youtube,
        amazon,
      };

      const db = firebase.firestore();
      const docRef = db.collection("shops").doc(userInfo.shopName);

      const action =
        mode === "update"
          ? docRef.update({ userSalesChannels })
          : docRef.set({ userSalesChannels }, { merge: true });

      action
        .then(() => {
          dispatch(salesChannelAction({ ...userSalesChannels }));
          notify(
            "success",
            mode === "update"
              ? "Updated channels successfully"
              : "Added channels successfully"
          );
        })
        .catch((error) => {
          console.error("Error saving channels: ", error);
        });
    } else {
      alert("Please add at least one valid link (more than 6 characters).");
    }
  };

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);

  useEffect(() => {
    if (inputRef1.current) {
      inputRef1.current.focus();
    }
  }, []);

  const firstKeyDown = (e) => {
    if (e.key === "Enter" && inputRef2.current) {
      inputRef2.current.focus();
    }
  };

  const secondKeyDown = (e) => {
    if (e.key === "Enter" && inputRef3.current) {
      inputRef3.current.focus();
    }
  };

  const thirdKeyDown = (e) => {
    if (e.key === "Enter" && inputRef4.current) {
      inputRef4.current.focus();
    }
  };

  const forthKeyDown = (e) => {
    if (e.key === "Enter" && inputRef5.current) {
      inputRef5.current.focus();
    }
  };

  return (
    <>
      <div className={styling.AddChannels}>
        <div className={styling.AddChannelsInner}>
          <div className={styling.closeIconDiv}>
            <button
              type="button"
              className={styling.closeButton}
              onClick={toggleChannel}
            >
              <MdClose className={styling.closeIcon} />
            </button>
          </div>

          <div className={styling.formContent}>
            <div className={styling.formHeader}>
              <h2 className={styling.formHeading}>
                Connect your sales channels
              </h2>
              <p className={styling.formSubHeading}>
                Paste the full URL for each channel you use. You can update
                these anytime.
              </p>
            </div>

            <div className={styling.channelsGrid}>
              <div className={styling.channelRow}>
                <div className={styling.channelLabel}>
                  <RiFacebookFill className={styling.socialIcons} />
                  <span>Facebook</span>
                </div>
                <input
                  type="text"
                  ref={inputRef1}
                  onKeyDown={firstKeyDown}
                  className={styling.channelInput}
                  placeholder="https://facebook.com/yourpage"
                  value={facebook}
                  onChange={(e) => setFacebook(e.target.value)}
                  disabled={guestUser}
                />
              </div>

              <div className={styling.channelRow}>
                <div className={styling.channelLabel}>
                  <FiInstagram className={styling.socialIcons} />
                  <span>Instagram</span>
                </div>
                <input
                  type="text"
                  ref={inputRef2}
                  onKeyDown={secondKeyDown}
                  className={styling.channelInput}
                  placeholder="https://instagram.com/yourstore"
                  value={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                  disabled={guestUser}
                />
              </div>

              <div className={styling.channelRow}>
                <div className={styling.channelLabel}>
                  <AiOutlineYoutube className={styling.socialIcons} />
                  <span>YouTube</span>
                </div>
                <input
                  type="text"
                  ref={inputRef3}
                  onKeyDown={thirdKeyDown}
                  className={styling.channelInput}
                  placeholder="https://youtube.com/yourchannel"
                  value={youtube}
                  onChange={(e) => setYoutube(e.target.value)}
                  disabled={guestUser}
                />
              </div>

              <div className={styling.channelRow}>
                <div className={styling.channelLabel}>
                  <RiAmazonFill className={styling.socialIcons} />
                  <span>Amazon</span>
                </div>
                <input
                  type="text"
                  ref={inputRef4}
                  onKeyDown={forthKeyDown}
                  className={styling.channelInput}
                  placeholder="https://amazon.in/yourstore"
                  value={amazon}
                  onChange={(e) => setAmazon(e.target.value)}
                  disabled={guestUser}
                />
              </div>
            </div>

            <div className={styling.footerRow}>
              {guestUser && (
                <p className={styling.guestNote}>
                  You’re in demo mode — sign in to connect and edit your
                  channels.
                </p>
              )}

              <button
                ref={inputRef5}
                className={styling.confirmButton}
                disabled={guestUser}
                onClick={() => {
                  toggleChannel();
                  handleSave(updateChannel ? "update" : "create");
                }}
              >
                {guestUser
                  ? "Please sign in"
                  : updateChannel
                  ? "Update channels"
                  : "Save channels"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default AddChannels;
